import * as Popover from '@radix-ui/react-popover';
import { ReactNode } from 'react';

import { PopoverContent, Wrapper } from './Popover.styles';

type PopoverComponentProps = {
  align?: 'center' | 'start' | 'end';
  content: ReactNode;
  maxWidth?: string;
  trigger: ReactNode;
};

export const PopoverComponent = ({ align = 'center', content, maxWidth, trigger }: PopoverComponentProps) => {
  return (
    <Popover.Root>
      <Popover.Trigger asChild>{trigger}</Popover.Trigger>
      <Popover.Portal>
        <PopoverContent align={align} className="PopoverContent" sideOffset={5}>
          <Wrapper $maxWidth={maxWidth}>{content}</Wrapper>
        </PopoverContent>
      </Popover.Portal>
    </Popover.Root>
  );
};
